import React from "react";
import { Lightbulb, LightbulbOutlined } from "@mui/icons-material";

/**
 * Get icon for brightness/light widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getBrightnessIcon = (widget = null) => {
  // Determine if light is on
  const isOn = widget?.items?.$o1?.value === "on";

  const iconProps = {
    style: {
      fontSize: "1.5rem",
      paddingBottom: "2px",
      color: isOn ? "#FFD700" : undefined, // Yellow only when on
    },
  };

  // Use filled icon when on, outlined when off
  return isOn ? (
    <Lightbulb {...iconProps} />
  ) : (
    <LightbulbOutlined {...iconProps} />
  );
};

export const getBrightnessSubtitle = (widget = null) => {
  if (!widget) return "";

  const isOn = widget?.items?.$o1?.value === "on";
  const brightness = Number(widget?.items?.$b1?.value);

  if (!isOn) {
    return "Off";
  }

  if (brightness !== undefined && !isNaN(brightness)) {
    return `On, ${Math.round(brightness)}%`;
  }

  return "On";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getBrightnessPatterns = () => {
  return [
    "basic.device.onoff_brightness_colortemperature",
    "basic.device.onoff_brightness_colorrgb",
    "basic.device.onoff_brightness_color",
    "basic.device.onoff_brightness",
    "basic.device.brightness",
    "basic.device.onoff",
  ];
};
